import React, { FC } from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@material-ui/pickers';

interface DateFieldProps {
  disabled?: boolean;
  label: string;
  onChange: (date: MaterialUiPickersDate) => void;
  value?: Date;
}

const DateField: FC<DateFieldProps> = ({ value, label, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <DatePicker
      disabled={disabled}
      format="ll"
      onChange={onChange}
      okLabel={t('label.confirm')}
      todayLabel={t('label.today')}
      clearLabel={t('label.reset')}
      cancelLabel={t('label.cancel')}
      emptyLabel={t('label.select day')}
      label={label}
      inputVariant="outlined"
      showTodayButton
      clearable
      disableFuture
      value={value ?? null}
    />
  );
};

export default DateField;
